import {
  updateToCamelCase,
  getValueType,
} from './util';

const getVal = require('lodash/get');

const leFileTypeConstants = {
  leDocumentRequired: 'Business Name Confirmation Document',
  individualNameDocRequired: 'Name Confirmation Document',
  individualAddressDocRequired: 'Address Confirmation Document',
  individualNameAndAddressDocRequired: 'Name & Address Confirmation Document',
  individualIdDocRequired: 'National ID Confirmation Document',
};
/**  Functions for creating rows in JSON starts */
/* Function to add field dynamic display properly to a row */
export const checkForFieldDynamicDisplay = (componentProps = {}, customProps = {}) => {
  let fieldDynamicDisplay = null;
  const { entityName } = customProps;
  if (componentProps?.fieldDynamicDisplay) {
    if (componentProps?.fieldDynamicDisplay.mapResponse) {
      fieldDynamicDisplay = { ...componentProps?.fieldDynamicDisplay };
      let createdPropertyKey = '';
      if (fieldDynamicDisplay.entitySpecific) {
        createdPropertyKey = `${entityName} ${fieldDynamicDisplay.propertyKey}`;
      } else {
        createdPropertyKey = `${fieldDynamicDisplay.propertyKey}`;
      }
      if (fieldDynamicDisplay.indexToReplace && fieldDynamicDisplay.indexToReplace.length > 0) {
        createdPropertyKey = fieldDynamicDisplay.indexToReplace.reduce((acc, el) => {
          acc = acc.replace(el, customProps[el]);
          return acc;
        }, createdPropertyKey);
      }
      fieldDynamicDisplay.propertyKey = `${fieldDynamicDisplay.parentKey}.${createdPropertyKey}`;
    } else if (componentProps?.fieldDynamicDisplay.multiKeyValueMappings) {
      fieldDynamicDisplay = { ...componentProps?.fieldDynamicDisplay };
      let { multiKeyValueMappings } = fieldDynamicDisplay;
      multiKeyValueMappings = Object.entries(multiKeyValueMappings).reduce((acc, [key, value]) => {
        acc[`${fieldDynamicDisplay.parentKey}.${key}`] = value;
        return acc;
      }, {});
      fieldDynamicDisplay.multiKeyValueMappings = multiKeyValueMappings;
    }
  }
  return fieldDynamicDisplay;
};

const mergeAssoComponentProps = (elementProps, assoProps) => {
  const newElementProps = { ...elementProps };
  /* eslint-disable no-restricted-syntax -- need */
  for (const [key, value] of Object.entries(assoProps)) {
    if (newElementProps[key] && typeof newElementProps[key] === 'object' && typeof value === 'object') {
      const existingProperty = newElementProps[key];
      const assoProperty = value;
      if (Array.isArray(value) && Array.isArray(newElementProps[key])) {
        newElementProps[key] = [...newElementProps[key], ...value];
      } else {
        newElementProps[key] = mergeAssoComponentProps(existingProperty, assoProperty);
      }
    } else {
      newElementProps[key] = value;
    }
  }
  /* eslint-enable no-restricted-syntax -- need */
  return newElementProps;
};

/** Function to generate row for le mapping */
export const generateRow = (rowProps, entityProps, finalJSON = []) => {
  const {
    componentMapping, baseComponentTemplates, key, entityIndex, index, assoComponentProps,
  } = rowProps;
  const {
    entityName, entityId, currentEntity, setCurrentEntity,
  } = entityProps;
  const elementType = componentMapping[key];
  return elementType?.componentScope.reduce((acc, ele) => {
    const baseJSON = {
      id: 'row',
      cssProperties: {
        style: 'row',
      },
      childElements: [],
    };
    const element = { ...baseComponentTemplates[ele.type] };
    const { componentProps, payloadDest } = ele;
    let elementProps = structuredClone({ ...componentProps });
    if (assoComponentProps) {
      elementProps = mergeAssoComponentProps(elementProps, assoComponentProps);
    }
    if (elementProps?.replaceIndexesBeforeMapping && elementProps?.mapReplaceItems) {
      elementProps.mapReplaceItems = [...elementProps.mapReplaceItems].map((item) => {
        elementProps.indexToReplace.forEach((i) => {
          item.value = item.value.replace(i, rowProps[i]);
        });
        return item;
      });
    }

    let finalElement = { ...element, ...elementProps, entityIndex };
    const dynamicProps = { entityName, entityIndex, index };
    const fieldDynamicDisplay = checkForFieldDynamicDisplay(elementProps, dynamicProps);
    if (fieldDynamicDisplay) {
      finalElement = { ...finalElement, fieldIndicator: false, fieldDynamicDisplay };
    }
    baseJSON.childElements.push({ ...finalElement });
    acc = [...acc, baseJSON];
    if (payloadDest) {
      const { uploadedDocuments } = currentEntity;
      if (uploadedDocuments[entityName]) {
        currentEntity.uploadedDocuments[entityName] = uploadedDocuments[entityName].map((doc) => {
          if (doc.type === key) {
            if (finalElement.mapReplaceItems) {
              const fieldIdReplaceItem = finalElement.mapReplaceItems.find((item) => item.replace === 'fieldId');
              const { fieldId } = finalElement;
              if (fieldIdReplaceItem) {
                const { key: fieldKey } = fieldIdReplaceItem;
                doc[payloadDest] = fieldId.replace(fieldKey, updateToCamelCase(entityId));
              } else {
                doc[payloadDest] = fieldId;
              }
            }
          }
          return doc;
        });
      }
      setCurrentEntity(structuredClone(currentEntity));
    }
    return acc;
  }, finalJSON);
};

/** Function to generate associated components if applicable */
export const checkAndGenerateAssociatedComponents = (rowProps, entityProps, finalJSON) => {
  const { componentMapping, key } = rowProps;
  if (componentMapping && key && componentMapping[key]) {
    const { associatedComponents } = componentMapping[key];
    if (associatedComponents) {
      associatedComponents.forEach((associatedComponent) => {
        const { key: assoKey, componentProps } = associatedComponent;
        const assoProps = structuredClone({ ...componentProps });
        const assoRowProps = { ...rowProps, key: assoKey, assoComponentProps: assoProps };
        finalJSON = generateRow(assoRowProps, entityProps, finalJSON);
      });
    }
  }
  return finalJSON;
};

/** Function to trigger generate row and generate associated components */
export const triggerGenerateRow = (rowPropsData, specificProps, finalJSON) => {
  let { rowProps, entityProps } = rowPropsData;
  const {
    key, entityName, entityId, statusScope, currentStatus,
  } = specificProps;
  if (statusScope === currentStatus) {
    rowProps = {
      ...rowProps, key,
    };
    entityProps = { ...entityProps, entityName, entityId };
    finalJSON = generateRow(rowProps, entityProps, finalJSON);
    finalJSON = checkAndGenerateAssociatedComponents(rowProps, entityProps, finalJSON);
  }
  return finalJSON;
};

/** Recurssive function which will trigger generate row by value type */
export const iterateThroughEntity = (props, entity, finalJSON) => {
  const { rowProps, entityProps } = props;
  const { componentMapping } = rowProps;
  const { currentEntity } = entityProps;
  if (entity) {
    /* eslint-disable no-restricted-syntax -- need */
    for (const [key, value] of Object.entries(entity)) {
      switch (getValueType(value)) {
        case 'string':
          if (value === 'Y') {
            const elementType = componentMapping[key];
            const specificProps = {
              key,
              entityName: entity.leName || entity.individualName,
              entityId: entity.taxId || entity.individualRefId,
              statusScope: elementType.statusScope,
              currentStatus: currentEntity.status || 'open',
            };
            finalJSON = triggerGenerateRow({ rowProps, entityProps }, specificProps, finalJSON);
          }
          break;
        case 'array':
          if (value.length > 0) {
            for (const [index, item] of value.entries()) {
              const val = item;
              const updateRowProps = { ...rowProps, index };
              const updatedProps = { ...props, rowProps: updateRowProps };
              finalJSON = iterateThroughEntity(updatedProps, val, finalJSON);
            }
          }
          break;
        default:
          break;
      }
    }
  }
  /* eslint-enable no-restricted-syntax -- need */

  return finalJSON;
};

/** Function to create Doc Upload JSON */
export const getDocUploadJSON = (templateProps, entityDataProps) => {
  const {
    componentMapping, baseComponentTemplates, staticComponents,
  } = templateProps;
  const { currentEntity, setCurrentEntity, entityIndex } = entityDataProps;
  let finalJSON = [];

  const rowProps = {
    componentMapping, baseComponentTemplates, entityIndex,
  };
  const entityProps = { currentEntity, setCurrentEntity };

  staticComponents.forEach((staticComponent) => {
    const elementType = componentMapping[staticComponent];
    const { statusScope } = elementType;
    const { leName, status } = currentEntity;
    const specificProps = {
      key: staticComponent, entityName: leName, entityId: '', statusScope, currentStatus: status || 'open',
    };
    finalJSON = triggerGenerateRow({ rowProps, entityProps }, specificProps, finalJSON);
  });

  const props = { rowProps, entityProps };
  finalJSON = iterateThroughEntity(props, currentEntity, finalJSON);
  // console.log(finalJSON);
  return finalJSON;
};

/** Function which will be called from the component to initiate Doc Upload JSON */
export const getLeJSONMapping = (type, formTemplate, entityDataProps) => {
  let LeMappingData = [];
  switch (type) {
    case 'docUpload':
      LeMappingData = getDocUploadJSON(formTemplate, entityDataProps);
      break;
    default:
      break;
  }
  return LeMappingData;
};

/**  Functions for creating rows in JSON ends */

/** Functions for generating table data starts */

/** Creating enitity template for uploadedDocuments */
export const createEntityTemplateData = (uploadedDocuments, entity, associatedProps = null) => {
  let allKeys = ['type', 'fileType', 'fileName', 'documentType', 'fileSrc', 'documentTypeSrc'];
  if (associatedProps) {
    allKeys = [...allKeys, 'isAssociated', 'dependsOn', 'dependsOnValue'];
  }

  Object.entries(entity).forEach(([key, value]) => {
    if (value === 'Y') {
      let valuesToSet = {
        type: key,
        fileType: leFileTypeConstants[key],
        ...associatedProps,
      };

      if (associatedProps) {
        valuesToSet = { ...valuesToSet, ...associatedProps };
      }
      const documentJSON = Object.fromEntries(
        allKeys.map((k) => [k, valuesToSet[k] || ''])
      );

      if (!uploadedDocuments[entity?.name]) {
        uploadedDocuments[entity?.name] = [
          documentJSON,
        ];
      } else {
        const index = uploadedDocuments[entity?.name].findIndex((doc) => doc.type === key);
        if (index < 0) {
          uploadedDocuments[entity?.name].push(documentJSON);
        }
      }
    }
  });
  return uploadedDocuments;
};

/** Check if associated document is there, if yes add it to uploadedDocuments */

export const generateAssociatedTemplateData = (mappedComponent, entityProp, uploadedDocuments) => {
  let newUploadedDocuments = { ...uploadedDocuments };
  const { entityName, entityId } = entityProp;
  if (mappedComponent) {
    const { associatedComponents } = mappedComponent;
    if (associatedComponents) {
      /* eslint-disable no-restricted-syntax -- need */
      for (const associatedComponent of associatedComponents) {
        const { key, dependsOn, dependsOnValue } = associatedComponent;
        const entity = { [key]: 'Y', name: entityName, entityId };
        const assoProps = { isAssociated: true, dependsOn, dependsOnValue };
        const { updateValueString } = associatedComponent;
        if (updateValueString && updateValueString.length > 0) {
          for (const valueString of updateValueString) {
            const { replace } = valueString;
            const valueToReplace = associatedComponent[replace];
            const { key: assoKey } = valueString;
            assoProps[replace] = valueToReplace.replace(assoKey, updateToCamelCase(entityId));
          }
        }
        newUploadedDocuments = createEntityTemplateData(newUploadedDocuments, entity, assoProps);
      }
      /* eslint-enable no-restricted-syntax -- need */
    }
  }
  return newUploadedDocuments;
};

/** Recursive function to generate uploadedDocuments Data */
export const generateUploadDocData = (currentEntityData, componentMapping, uploadedDocuments) => {
  let newUploadedDocs = { ...uploadedDocuments };
  /* eslint-disable no-restricted-syntax -- need */
  /* eslint-disable max-len -- need */
  for (const [key, value] of Object.entries(currentEntityData)) {
    switch (getValueType(value)) {
      case 'string':
        if (value === 'Y') {
          const name = currentEntityData.leName || currentEntityData.individualName;
          const id = currentEntityData.taxId || currentEntityData.individualRefId;
          const entity = { [key]: value, name };
          const elementType = componentMapping[key];
          newUploadedDocs = createEntityTemplateData(newUploadedDocs, entity);
          if (elementType) {
            const entityProp = { entityName: name, entityId: id };

            newUploadedDocs = generateAssociatedTemplateData(elementType, entityProp, newUploadedDocs);
          }
        }
        break;
      case 'array':
        if (value.length > 0) {
          for (const val of value) {
            newUploadedDocs = generateUploadDocData(val, componentMapping, newUploadedDocs);
          }
        }
        break;
      default:
        break;
    }
  }
  /* eslint-enable max-len -- need */
  /* eslint-enable no-restricted-syntax -- need */

  return newUploadedDocs;
};

/** Function to initiate uploadedDocuments generatio  */
export const generateConfirmEntityTemplateData = (currentEntityData, componentMapping) => {
  let uploadedDocuments = currentEntityData?.uploadedDocuments || {};
  uploadedDocuments = generateUploadDocData(currentEntityData, componentMapping, uploadedDocuments);
  return {
    ...currentEntityData,
    uploadedDocuments,
  };
};

/** Function to generate table data for requested and uploaded tables */
export const getLeTableData = (entityData, entityIndex, selectKey) => {
  let tempData = [];
  const currentData = getVal(entityData.entities[entityIndex], selectKey);
  const currentStatus = entityData.entities[entityIndex].status;
  if (currentData) {
    /* eslint-disable no-restricted-syntax -- need */
    for (const [key, value] of Object.entries(currentData)) {
      const valueArray = value.filter((val) => {
        if (currentStatus !== 'completed') {
          return !val.isAssociated;
        }
        return !!val.fileName && !!val.documentType;
      }).map((val, index) => ({
        key: `${key}-${index}`,
        entityName: key,
        ...val,
      }));

      tempData = [...tempData, ...valueArray];
    }
    /* eslint-enable no-restricted-syntax -- need */
  }
  return tempData;
};

/** Functions for generating table data ends */

/** Functions for validating uploads starts */
/** Function to check whether associated components are valid */
export const haveValidAssociatedComponents = (documentProps, globalProps) => {
  const { files, documentTypeSrc, documentType } = documentProps;
  const { fileNameMap, filledFormData } = globalProps;
  const associateFileArray = files.filter((file) => {
    const { isAssociated, dependsOn, dependsOnValue } = file;
    return isAssociated && dependsOn === documentTypeSrc && dependsOnValue === documentType;
  });
  if (associateFileArray.length > 0) {
    return associateFileArray.every((file) => {
      const fileName = fileNameMap[file.fileSrc];
      const docType = filledFormData[file.documentTypeSrc];
      return fileName && docType;
    });
  }

  return false;
};

/** Functions to validate uploaded files for confirming uploads */
export const validateUploadedFiles = (params) => {
  const { griffinFileInfo, currentEntity, filledFormData } = params;
  const fileNameMap = Object.fromEntries(griffinFileInfo.map((info) => [info.fileFrom, info.name]));
  let allDocumentsValid = true;
  const updatedUploadedDocuments = Object.fromEntries(
    Object.entries(currentEntity.uploadedDocuments).map(([key, files]) => {
      const updatedFiles = files.map((file) => {
        const fileName = fileNameMap[file.fileSrc];
        const documentType = filledFormData[file.documentTypeSrc];
        if (!file.isAssociated) {
          if (!fileName || !documentType) {
            const docProps = { files, documentTypeSrc: file.documentTypeSrc, documentType };
            const dataProps = { fileNameMap, filledFormData };

            if (!haveValidAssociatedComponents(docProps, dataProps)) {
              allDocumentsValid = false;
            }
          }
        }
        return {
          ...file,
          ...fileName && { fileName },
          ...documentType && { documentType },
        };
      });
      return [key, updatedFiles];
    })
  );
  currentEntity.uploadedDocuments = updatedUploadedDocuments;
  const clonedCurrentEntity = structuredClone(currentEntity);
  return { allDocumentsValid, currentEntity: { ...clonedCurrentEntity, status: allDocumentsValid ? 'completed' : 'open' } };
};

/** Functions for validating uploads ends */
